import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_comply_w_legal_reqs_regarding_medical_checks_for_w'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_comply_w_legal_reqs_regarding_medical_checks_for_w',
  name: 'Does the facility comply with legal requirements regarding medical checks for workers?',
  description:
    'This question covers all types of medical checks for all workers, including pre-assignment, periodic and after-employment checks. \r\r\n\r\r\nConsult applicable legal requirements. \r\r\n\r\r\nIf there are no applicable legal requirements, answer No applicable legal requirements.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 3,
      slcpOptionName: 'yes-no-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-50--3',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 16780,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
